import React, { useState } from "react";
import { useTheme } from "../lib/ThemeContext";

/**
 * Logo — uses PNG at /logo-liquor-studio.png with a text-logo fallback.
 * Pass `size` (px height). Auto-applies a subtle drop shadow in light mode
 * since the PNG has a black background.
 */
export const Logo = ({ size = 56, variant = "auto", className = "" }) => {
    const [imgFailed, setImgFailed] = useState(false);
    const { theme } = useTheme();
    const useText = variant === "text" || imgFailed;

    if (useText) {
        return (
            <span
                className={`logo-text-fallback ${className}`}
                aria-label="Liquor Studio"
                data-testid="logo-text"
                style={{ fontSize: size * 0.55 }}
            >
                <span className="l-word" style={{ fontSize: size * 0.55 }}>
                    Liquor
                </span>
                <span className="l-studio" style={{ fontSize: size * 0.6 }}>
                    STUDIO
                </span>
            </span>
        );
    }

    const isLight = theme === "light";
    return (
        <img
            src={`/logo-liquor-studio.png?v=3`}
            alt="Liquor Studio — Clinton, Missouri's Premier Spirits Destination"
            data-testid="logo-image"
            onError={() => setImgFailed(true)}
            className={className}
            style={{
                height: size,
                width: "auto",
                display: "block",
                filter: isLight ? "drop-shadow(0 2px 8px rgba(184,130,26,0.35))" : "drop-shadow(0 2px 12px rgba(245,176,39,0.25))",
                borderRadius: isLight ? 8 : 0,
                transition: "filter 0.25s ease, height 0.3s ease",
            }}
        />
    );
};

export default Logo;
